export default {"src":"/_next/static/media/icon-phone-2.f8575679.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};